import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Angulartics2 } from 'angulartics2';
import { environment } from '../../../environments/environment';
import { SharedStore } from '../../core/providers/shared';



@Component({
	selector:		'section[page-home]',
	templateUrl:	'home.html',
})
export class HomeComponent {
	public isOutlookWinStringCollapsed: boolean = true;

	public signature: any = {
		name: 'Szabolcs Martényi',
		email: 'martenyi.szabolcs@hps.hu',
		company: 'HPS Communication',
		division: 'group',
		position: 'head of logistics',
		phone: '703803606',
	};

	public signaturePreview: any;
	public signatureUrl: any;
	public url = window.location.href;

	public companies: string[] = [
		'HPS Communication',
		'HPS Trade',
		'TDL',
		'Moon',
	];

	public divisonsCommunication: string[] = [
		'group',
		'communication',
		'advertising',
		'creative',
		'digital',
		'pr',
		'event',
	];

	public divisonsTrade: string[] = [
		'sales',
		'retail',
		'field',
		'staff',
		'horeca',
		'student co.',
		'finance',
		'controlling',
		'payroll',
		'hr',
		'paperhill',
		'e-commerce',
	];

	public positions: string[] = [
		'Marketing Supervisor',
		'Műszaki tervező',
		'Junior Designer',
		'Production Business Unit Director',
		'Field Junior Account Executive',
		'Art Director ',
		'Coach',
		'Integrált Account Director',
		'Digital Account Manager',
		'Marketing Supervisor',
		'Műhelyes ',
		'Digital Account Manager',
		'Integrált Senior Account Manager',
		'Event Account Manager',
		'Art Director',
		'Integrált Account Manager',
		'HR Senior Specialist',
		'Integrált Account Manager',
		'Digital Media Executive',
		'Digital Analyst',
		'Frontend Developer',
		'Hostess Koordinátor',
		'Futár',
		'PR Junior Account Executive ',
		'Social Media Manager',
		'Event Account Manager',
		'Office Manager',
		'Event Creative',
		'Backend Developer',
		'Sofőr',
		'Marketing Supervisor',
		'Hostess Koordinátor Asszisztens',
		'Sales Supervisor',
		'Integrált Account Executive',
		'Senior Social Content Specialist',
		'Operatőr, Vágó',
		'Digital Senior Product Designer',
		'Production Junior Project Manager',
		'Event Account Executive',
		'Junior Kontroller',
		'HR Junior Specialist',
		'Junior Sales Account Executive',
		'Integrált Account Manager',
		'Sales Supervisor',
		'Junior Recruiter',
		'Business Transformation Manager',
		'Senior Art Director',
		'Integrált Account Director',
		'Retail Operation Manager',
		'Sales Supervisor',
		'Integrált Account Director',
		'Junior Sales Account Executive',
		'Recruitment & Employer Branding Leader',
		'Coach',
		'PR Consultant',
		'PR Junior Account Executive ',
		'Marketing Supervisor',
		'Junior Copywriter',
		'Field Divízió Vezető',
		'Senior Staff',
		'Field Junior Account Executive',
		'Event Account Executive ',
		'Group Chief Accountant',
		'Junior Könyvelő',
		'Head of Digital Media',
		'Backend Developer',
		'Sofőr',
		'Social Content Specialist',
		'DTP Operátor',
		'Senior Könyvelő',
		'Sales Account Manager',
		'Sales Supervisor',
		'Senior Webdesigner',
		'Marketing Supervisor',
		'Head of Logisztika',
		'Junior Art Director',
		'Sales Supervisor',
		'Field Senior Account Manager',
		'Social Junior Media Manager',
		'Sales Supervisor',
		'Trade Business Unit Director',
		'Event Junior Account Executive',
		'Copywriter',
		'Hostess Koordinátor',
		'Creative Director',
		'Hostess Koordináció Vezető',
		'Senior PR Consultant',
		'Retail Account Manager',
		'PR Expert',
		'Senior PR Consultant',
		'Sales Account Manager',
		'Production Project Manager',
		'Digital Account Executive',
		'Raktáros',
		'Event Senior Account Manager',
		'Junior Könyvelő',
		'Futár',
		'Social Content Designer',
		'Account Director',
		'Office Manager',
		'Integrált Senior Account Manager',
		'Junior Könyvelő',
		'Experience Business Unit Director',
		'Senior Frontend Developer',
		'PR Junior Account Executive ',
		'Sales Divízió Vezető',
		'Sales Account Manager',
		'Sales Account Manager',
		'Event Junior Account Executive',
		'Social Senior Media Manager',
		'Sales Account Executive',
		'Beszerzési Vezető',
		'Integrált Senior Account Manager',
		'Temporary Staffing Manager',
		'Marketing Supervisor',
		'Műhelyes ',
		'Integrált Account Manager',
		'Junior Könyvelő',
		'Junior Motion Designer',
		'Production Senior Project Manager',
		'Sales Supervisor',
		'Production Senior Project Manager',
		'Event Account Manager',
		'Office Coordinator ',
		'Ügyvezető Igazgató',
		'Gyártásvezető',
		'Junior Recruiter',
		'Event Business Unit Director',
		'Field Account Manager',
		'Junior Recruiter',
		'Traffic Manager',
		'Event Account Manager',
		'PR Expert',
		'Integrált Account Executive',
		'Senior Art Director',
		'Műhelyes ',
		'HR Projekt Koordinátor',
		'Senior Sales Account Manager ',
		'Sales Operation Manager',
		'Kontrolling Vezető',
		'Marketing Supervisor',
		'Agency Producer',
		'Sitebuilder',
		'HR Strategic Advisor for HPS Group',
		'Webdesigner',
		'Junior Frontend Developer',
		'Customer Service Assistant',
		'Customer Service Manager',
		'Customer Service Intern',
		'Integrált Junior Account Executive',
		'Retail Account Director',
		'Junior Sales Account Executive',
		'Retail Account Executive',
		'Event Adminisztrátor',
		'Digital Operátor',
		'Event Junior Account Executive',
		'Integrált Senior Account Manager',
		'PR Junior Account Executive ',
		'Bérszámfejtés és TB tanácsadó ',
		'Field Divízió vezető',
		'Field Junior Account Executive',
		'Sales Supervisor',
		'Integrált Account Director',
		'Marketing Supervisor',
		'Marketing Supervisor',
		'Területi vezető',
		'Junior Recruiter',
		'Sales Account Manager',
		'Integrált Account Executive',
		'',
		'Experience Business Unit Director',
		'Senior Digital Account Manager ',
		'Production Project Manager',
		'Field Account Manager',
		'Junior Sales Account Executive',
		'Marketing Supervisor',
		'Junior Copywriter',
		'Pénzügyi Asszisztens',
		'Social Content Designer',
		'Digital Designer',
		'Sofőr/raktáros',
		'Ügyvezető Igazgató',
		'Marketing Supervisor',
		'Field Junior Account Executive',
		'Senior Könyvelő',
		'Műhelyvezető',
		'Digital Account Manager',
		'Kreatív Operatív Vezető',
		'Staff',
		'Sales Supervisor',
		'Production Senior Project Manager',
		'Digital Account Director',
		'Marketing Supervisor',
		'Országos Területi Vezető',
		'Junior Designer',
		'Marketing Supervisor',
		'Junior Könyvelő',
		'Technikus',
		'Retail Account Executive',
		'Production Senior Project Manager',
		'Sales Supervisor',
		'Lead Developer',
		'Sales Account Manager',
		'Production Senior Project Manager',
		'Raktáros',
		'Integrált Account Manager',
		'Retail Senior Account Manager',
		'Creative Grouphead',
		'Field Account Manager',
		'Copywriter',
		'Digital Media Manager',
		'Field Account Manager',
		'Event Senior Account Manager',
		'Integrált Senior Account Manager',
		'Sales Account Executive',
		'Event Junior Account Executive',
		'Stratégiai Igazgató',
		'Retail Senior Account Manager',
		'Sales supervisor',
		'Social Trainee',
		'Field Senior Account Manager',
		'Sales Account Manager',
		'Kreatív és Stratégiai Igazgató',
		'Marketing Supervisor',
		'DTP Operátor',
		'Head of Sales',
		'Raktáros',
		'Integrált Account Executive',
		'Junior Sales Account Executive',
		'Head of PR',
		'Event Account Director',
		'',
		'Integrált Account Manager',
		'Integrált Account Manager',
		'Social Content Designer',
		'Field Account Manager',
		'Integrált Account Executive',
		'Event Account Executive',
		'Integrált Senior Account Manager',
		'Integrált Junior Account Executive',
		'Integrált Junior Account Executive',
		'Event Account Executive',
		'Hostess Koordinátor',
		'Head of HR',
		'Integrált Junior Account Executive',
		'HR Asszisztens',
		'Integrált Account Manager',
		'PR Junior Account Executive ',
		'Integrált Account Manager',
		'Digital Media Manager',
		'Event Creative',
		'Trade Business Unit Director',
		'Digital Trainee',
		'Webdesigner',
		'Event Junior Account Executive',
		'Copywriter',
		'Event Account Executive',
		'Integrált Junior Account Executive',
		'Junior Könyvelő',
		'Digital Media Manager',
		'Sales Account Manager',
		'DTP Operátor',
		'Junior Sales Account Executive',
		'Production Project manager',
		'PR Expert',
		'PR Junior Account Executive ',
		'Senior Art Director',
		'Integrált Junior Account Executive',
		'Event Account Director',
		'Field Account Manager',
		'Senior Copywriter (Creative Grouphead)',
		'Junior Könyvelő',
		'Event Account Manager',
		'Pénzügyi Asszisztens',
		'PR Expert',
		'Retail Account Executive',
		'Kontroller',
		'Gazdasági Vezető',
		'Digital Trainee',
		'PR Junior Account Executive ',
		'Integrált Senior Account Manager',
		'Retail Senior Account Manager',
		'Field Junior Account Executive',
		'Adminsztrátor',
		'Event Senior Account Manager',
		'Senior Copywriter',
		'Junior Art Director',
		'Digital Account Manager',
		'Digital Trainee',
		'Digital Trainee',
		'Field Junior Account Executive',
		'Műhelyes ',
		'Kontroller',
		'Event Account Manager',
		'Designer',
		'PR Junior Account Executive ',
		'Event Creative',
		'Senior Copywriter',
		'Production Gyakornok',
		'Integrált Account Manager',
		'Designer',
		'Social Media Manager',
		'Pénzügyi Asszisztens',
		'Pénzügyi Asszisztens',
		'Event Junior Account Executive',
		'Senior PR Consultant',
		'Pénzügyi Asszisztens',
		'Integrált Account Manager',
		'Integrált Account Executive',
		'Senior Performance Marketing Manager',
		'Printing-office/3D/DTP',
		'Logistics coordinator',
		'Event staff',
		'Senior event staff',
		'Senior carpenter',
		'Senior staff of workshop',
		'Head of territorial team leader',
		'Medium carpenter',
		'Head of workshop (carpenter, contractor)',
		'Head of workshop (printing-office)',
		'Recruiting Coordinator',
		'Junior Recruiting Coordinator',
		'Sales Junior Account Executive',
		'Sales Account Executive',
		'Sales Account Manager',
		'Sales Senior Account Manager',
		'Sales Operation Manager',
		'Credit Controller',
		'Junior Social Content Specialist',
		'Creative Group Head',
		'Developer Team Lead',
		'HR Manager',
		'Strategy Director',
		'Head of Data & Technology',
		'Performance Marketing Manager',
		'Recruiting Team Leader',
		'Head of AR/VR',
		'Junior Product Designer',
		'Logistics Project Manager',
		'Project Manager',
		'HR Trainee',
		'Managing Director',
		'CFO',
		'Head of Field',
		'Head of Sales',
		'Head of Retail',
		'Head of HoReCa',
		'Head of Logigistic',
		'Operations Manager',
		'Manager',
		'Trade Operations Manager',
		'Hostess Coordination Manager',
		'Coordination and Recruitment Manager',
		'Area Manager',
		'Coordination Team Leader',
		'Recruitment Team Leader',
		'senior account manager',
		'account manager',
		'account executive',
		'junior account execuitve',
		'senior koordinátor',
		'coordinator',
		'junior coordinator',
		'senior recuiter',
		'recruiter',
		'junior recruiter',
		'researcher',
		'junior graphic designer',
		'operations manager',
		'marketing supervisor',
		'sales supervisor',
		'finance coordinator',
		'senior accountant',
		'junior accountant',
		'senior controller',
		'controller',
		'junior controller',
		'senior payroll specialist',
		'payroll specialist',
		'HR specialist',
		'HR assistant',
		'office manager',
		'assistant',
		'receptionist',
		'production project manager',
		'production junior project manager',
		'driver',
		'storekeeper',
		'group chief accountant',
		'account director',
		'Promotions and Customer Coordinator',
		'Promotions and Customer Coordinator Intern',
		'operations development manager',
		'HR and Event Specialist',
		'client services director',
		'digital strategist and business developer',
		'lead account manager & social media strategist',
		'planner',
	];




	constructor(
		public shared: SharedStore,
		public angulartics2: Angulartics2,
		private sanitizer: DomSanitizer,
		private http: HttpClient,
	) {
		this.preparePositions();
		this.loadFromLocalStorage();
		this.preview();
	}

	public preview(callback?) {
		let signaturePreviewLink = 'signature-generator.php?';

		if (this.signature.name) {
			signaturePreviewLink += 'name=' + encodeURI(this.signature.name);
		}

		if (this.signature.position) {
			signaturePreviewLink += '&position=' + encodeURI(this.signature.position).replace('&', '%26');
		}

		if (this.signature.phone) {
			signaturePreviewLink += '&phone=' + encodeURI(this.signature.phone);
		}

		if (this.signature.email) {
			signaturePreviewLink += '&email=' + encodeURI(this.signature.email);
		}

		if (this.signature.division && this.signature.company !== 'TDL' && this.signature.company !== 'Moon') {
			signaturePreviewLink += '&division=' + encodeURI(this.signature.division);
		}

		if (this.signature.company) {
			signaturePreviewLink += '&company=' + encodeURI(this.signature.company);
		}

		// signaturePreviewLink = encodeURI(signaturePreviewLink);

		this.signaturePreview = this.sanitizer.bypassSecurityTrustResourceUrl(environment.API_URL + signaturePreviewLink);
		this.signatureUrl = signaturePreviewLink;

		if (callback) {
			callback();
		}

		this.saveToLocalStorage();
	}

	public save() {
		console.log(this.signature);
		this.preview(() => {
			console.log('signatureUrl', this.signatureUrl);
			console.log('signaturePreview', this.signaturePreview);
			window.open(environment.API_URL + this.signatureUrl, '_blank');

			this.http.get(this.signatureUrl)
			.subscribe((res) => {
				console.log(res);
			});
		});
	}

	private preparePositions() {
		const prefixes = [
			'communication',
			'group',
			'advertising',
			// 'creative',
			'trade',
			'digital',
			'digitál',
			'event',
			'integrált',
			'field',
			'retail',
			'sales',
		];

		const replaces = {
			'^(event|hr|social|pr) (junior|senior)': '$2 $1',
			'^(junior|senior) sales account (executive|manager)$': '',
			'^adminsztrátor$': 'adminisztrátor',
			' for hps group$': '',
			'^head of digital media$': 'head of perfomance marketing',
			'^head of logisztika$': 'head of logistics',
			'^senior digital account manager$': '',
		};

		const additional: string[] = [
			'head of creative',
			'head of social media',
			'head of horeca',
			'hr specialist',
			'creative producer',
			'senior controller',
			'ceo',
			'chief financial officer',
			'business unit director - online',
			'business unit director - offline',
			'business unit director - development',
			'business unit director - pr',
			'business unit director - event',
		];

		const fixedPositions: string[] = [
			'creative director',
			'digital strategist and business developer',
		];

		this.positions = [...this.positions, ...additional];

		this.positions = this.positions.map((position) => {
			position = position.toLowerCase();
			position = position.replace(/\(.+\)/, '');

			for (const key in replaces) {
				position = position.replace(new RegExp(key), replaces[key]);
			}

			prefixes.forEach((prefix) => {
				position = position.replace(new RegExp('^' + prefix + ' '), '');
			});

			position = position.trim();

			return position;
		});

		this.positions = [...this.positions, ...fixedPositions];

		this.positions = this.positions.filter((position) => {
			return position.length > 0;
		});

		this.positions = this.positions.filter((value, index, self) => {
			return self.indexOf(value) === index;
		});

		this.positions.sort((a, b) => {
			return a.localeCompare(b, 'hu');
		});
	}

	private saveToLocalStorage() {
		localStorage.setItem('signature', JSON.stringify(this.signature));
	}

	private loadFromLocalStorage() {
		const signatureJson = localStorage.getItem('signature');

		if (signatureJson) {
			const signature = JSON.parse(signatureJson);

			this.signature.name		= signature.name;
			this.signature.email	= signature.email;
			this.signature.phone	= signature.phone;

			if (this.companies.indexOf(signature.company) !== -1) {
				this.signature.company = signature.company;
			}

			if (this.divisonsCommunication.indexOf(signature.division) !== -1 || this.divisonsTrade.indexOf(signature.division) !== -1) {
				this.signature.division = signature.division;
			}

			if (this.positions.indexOf(signature.position) !== -1) {
				this.signature.position = signature.position;
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/pages/home/home.ts